<template>
  <div>
    <a-form-model
      class="fromStyle"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          @change="selectedDevice"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="设备网点" prop="device_id" ref="device_id">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          style="width:300px"
          placeholder="请选择网点设备"
          @change="selectedWorker"
          v-model="form.device_id"
        >
          <a-select-option
            v-for="(item, i) in deviceList"
            :key="i"
            :value="item.device_id"
            >{{ item.device_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="员工姓名" prop="user_id">
        <a-select
          style="width: 70%; margin-right: 10px"
          placeholder="请选择员工"
          show-search
          :filter-option="filterOption"
          v-model="form.user_id"
        >
          <a-select-option
            v-for="(item, i) in workerList"
            :key="i"
            :value="item.user_id"
            >{{ item.user_name + "&nbsp;" + item.phone }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item ref="date" label="日期" prop="date">
        <a-date-picker @change="onChangeDate" v-model="form.date" />
      </a-form-model-item>
      <a-form-model-item ref="title" label="标题" prop="title">
        <a-input v-model="form.title" type="text" />
      </a-form-model-item>
      <a-form-model-item ref="content" label="内容" prop="content">
        <a-input v-model="form.content" type="textarea" />
      </a-form-model-item>
      <a-form-model-item ref="owner_price" label="甲方价格" prop="owner_price">
        <a-input-number v-model="form.owner_price" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item ref="price" label="员工价格" prop="price">
        <a-input-number v-model="form.price" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 5 }">
        <a-button @click="resetForm">
          重置
        </a-button>
        <a-button style="margin-left: 10px;" type="primary" @click="onSubmit">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
import * as qiniu from "qiniu-js";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      form: {
        project_id: "",
        device_id: "",
        user_id: "",
        date: "",
        title: "",
        content: "",
        owner_price: "",
        price: "",
        assign_time: ""
      },
      rules: {
        device_id: [
          {
            required: true,
            message: "请选择设备网点",
            trigger: "change"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        user_id: [
          {
            required: true,
            message: "请选择员工",
            trigger: "change"
          }
        ],
        date: [{ required: true, message: "请选择日期", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        owner_price: [
          { required: true, message: "请输入甲方价格", trigger: "blur" }
        ],
        price: [
          {
            required: true,
            message: "请输入员工价格",
            trigger: "blur"
          }
        ]
      },
      proList: [],
      deviceList: [],
      workerList: []
    };
  },
  mounted() {
    this.getPro();
  },
  methods: {
    selectedDevice(id) {
      this.getDeviceList(id); //获取设备
    },
    selectedWorker(id) {
      this.getWorker(id); //获取员工
    },
    onChangeDate(date, dateString) {
      this.form.assign_time = dateString;
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getDeviceList(id) {
      this.form.device_id = "";
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/getListData";
      let params = {
        project_id: id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          this.deviceList = res.data.data;
          console.log(this.deviceList);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getWorker(deviceId) {
      this.form.user_id = "";
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device/getDeviceGuardList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          device_id: deviceId
        })
        .then(res => {
          if (res.data.code == 200) {
            this.workerList = res.data.data.data;
            console.log(this.workerList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Work_order/addtemporary";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            device_id: this.form.device_id,
            project_id: this.form.project_id,
            user_id: this.form.user_id,
            assign_time: this.form.assign_time,
            title: this.form.title,
            content: this.form.content,
            owner_price: this.form.owner_price,
            price: this.form.price
          };
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.resetForm();
              this.$emit("hideInAdd", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>
<style lang="less">
.fromStyle {
  margin-top: 30px;
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
    line-height: 32px;
  }
  .upImgStyle {
    position: relative;
    display: inline-block;
    min-width: 300px;
    vertical-align: top;
    > input {
      vertical-align: top;
      opacity: 0;
      position: absolute;
      width: 100px;
      height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      z-index: 1;
    }
    > img {
      vertical-align: top;
      display: inline-block;
      border: 1px solid #d9d9d9;
      width: 100px;
      height: 100px;
      text-align: center;
      line-height: 100px;
      margin-right: 10px;
      margin-top: 10px;
      i {
        line-height: 100px;
      }
    }
  }
}
</style>
